module.exports = __webpack_public_path__ + "img/logo-dinapsis.5a0baeed.svg";